// IMPORTANT: After modifying this file, update CHANGELOG.md with a summary of your changes.
// Add clear comments for non-obvious changes, including what replaced prior behavior, to avoid repeating failed fixes.

"use client";

import { useEffect, useState } from "react";

/**
 * Rotating-word animation for the home Hero variant.
 *
 * Isolated into its own client component so the rest of HeroBlock can stay
 * a server component (better streaming + static extraction for subpage
 * heroes that far outnumber home heroes on the site).
 *
 * Animation matches the original Hero.tsx: 3s dwell, exit slide-down, then
 * enter slide-up on the next word. Uses the globals.css word-enter /
 * word-exit keyframes that the legacy Hero already defined.
 */
export function HomeHeroRotator({ words }: { words: string[] }) {
  const [index, setIndex] = useState(0);
  const [animClass, setAnimClass] = useState("");

  useEffect(() => {
    if (words.length <= 1) return;
    const interval = setInterval(() => {
      setAnimClass("word-exit");
      const exitTimeout = setTimeout(() => {
        setIndex((prev) => (prev + 1) % words.length);
        setAnimClass("word-enter");
        const clearTimeout_ = setTimeout(() => setAnimClass(""), 500);
        return () => globalThis.clearTimeout(clearTimeout_);
      }, 500);
      return () => globalThis.clearTimeout(exitTimeout);
    }, 3000);
    return () => clearInterval(interval);
  }, [words.length]);

  if (words.length === 0) return null;

  return (
    <span className="relative h-24 md:h-32 lg:h-40 flex items-center justify-center overflow-hidden">
      {/* Size matches the flanking title lines (text-6xl md:text-8xl
          lg:text-9xl) — the hand-coded Hero uses the same scale for all
          three rows. */}
      <span
        className={`text-6xl md:text-8xl lg:text-9xl text-opichi-green-light inline-block ${animClass}`}
      >
        {words[index]}
      </span>
    </span>
  );
}
